<template>
    <div class="home">
        <div class="weui-toptips weui-toptips_warn js_tooltips">错误提示</div>
        <div class="container" id="container">
            <img :src="prodUrl" class="topImg">
            <div class="topTitle">{{ cpdy }}</div>
            <div class="mainDiv">
                <template>
                    <!-- <ul class="oneUl">
                        <li v-for="(item, index) in oneData" :key="index" class="oneLi">
                            <div v-if="index==0" class="oneLab">
                                追溯码列表
                            </div>
                            <div class="oneVal">
                                {{index+1}}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.value }}
                            </div>
                        </li>
                    </ul> -->
                    <div class="oneLab">
                        包装追溯码：{{ tracCode }}
                    </div>
                    <el-table :data="tableData" stripe style="width: 100%">
                        <el-table-column type="index" label="序号" min-width="30%">
                        </el-table-column>
                        <el-table-column prop="tracCode" label="产品追溯码" min-width="50%">
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <!--  底部  -->
            <!-- <div class="el-login-footer">
                <span>Copyright © 2025 河南良田优尚五金制造有限公司 All Rights Reserved.</span>
                <a href="https://beian.miit.gov.cn/">鲁ICP备2025167443号</a>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'
const service = axios.create({
    baseURL: 'https://api.hnltys.cn',
    // baseURL: 'http://120.27.10.18:9001',
    timeout: 20000
})
export default {
    components: {},
    mounted() {
        this.onLoad()
    },
    data() {
        return {
            tracCode: 'PCYS' + this.$route.params.id,
            pdfUrl: '',
            prodUrl: '',
            oneData: [],
            tableData: [],
            cpdy:''
        };
    },
    methods: {
        onLoad() {
            service({
                url: '/qhapi/info/getPacByTracCode',
                method: 'get',
                params: { tracCode: this.tracCode }
            }).then(res => {
                const data = res.data.data
                this.pdfUrl = data.jybg
                this.prodUrl = data.cptp
                this.cpdy = data.prodDy
                let prodList = data.prodList
                this.oneData = []
                prodList.forEach(element => {
                    this.oneData.push({ value: element.tracCode })
                })
                this.tableData = []
                prodList.forEach(element => {
                    this.tableData.push({ tracCode: element.tracCode })
                })
            })
        },
    }
};
</script>

<style scoped lang="less">
@sidebar-width: 100px
.page__hd {
    padding: 40px
}

.page__bd_spacing {
    padding: 0 15px
}
.topImg {
    width: 100%;
}

.mainDiv {
    position: relative;
    margin-top: 20px;
}

.topTitle {
    padding: 8px;
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    background-color: #142d96;
    letter-spacing: 1.2px;
}

.oneUl {
    position: absolute;
    top: 0px;
    width: calc(100% - 85px);
    display: flex;
    // left: 105px;
    flex-direction: column;
    justify-content: left;
    overflow-y: auto;
    margin-left: 1%;
    padding: 6px 8px;
    border-radius: 5px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 7px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, .1);
}

.oneLi {
    display: flex;
    flex-direction: column;
    justify-content: left;
    border-bottom: 1px dashed #cecece
}

.oneLab {
    font-size: 18px;
    color: #606266;
    text-align: left;
    line-height: 30px;
    height: 30px;
}

.oneVal {
    line-height: 39px;
    min-height: 39px;
    text-align: left;
}

.liImg {
    width: 250px;
    height: 187px;
}

/deep/ .van-sidebar-item--select::before {
    background-color: #142d96;
    height: 100%;
    width: 2px;
}

/deep/ .van-sidebar {
    width: 100px;
}
.el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
}
</style>
